import axios from "axios";
import { getToken } from "./auth.api";

const api = axios.create({ baseURL: process.env.REACT_APP_API_URL });

api.interceptors.request.use(config => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/* Chamado no kanban quando o usuário arrasta um ticket entre colunas.
   Registra a transição imediatamente, sem esperar o próximo sync. */
export async function bufferTransicao(id_ticket, status_anterior, status_novo) {
  try {
    const { data } = await api.post("/buffer/transicao", { id_ticket, status_anterior, status_novo });
    return data;
  } catch {
    // fire-and-forget — não bloqueia o fluxo principal
  }
}

/* Mutex: evita chamadas simultâneas de Gargalos + Programacao que
   chegariam ao backend antes de qualquer registro existir, gerando duplicatas. */
let _syncing = false;

/* Reconcilia o estado atual dos tickets com o log de buffer.
   Detecta mudanças feitas diretamente no Redmine (não via kanban).
   Chamado a cada load do kanban (60s). O backend é idempotente. */
export async function bufferSync(tickets) {
  if (!tickets?.length || _syncing) return;
  _syncing = true;
  try {
    const { data } = await api.post("/buffer/backfill", { tickets });
    return data;
  } catch {
    // silencioso
  } finally {
    _syncing = false;
  }
}

/* Move manualmente um ticket para o buffer "Finalizados" — controle interno,
   não altera o status do ticket no Redmine. */
export async function bufferFinalizar(id_ticket) {
  const { data } = await api.post("/buffer/finalizar", { id_ticket });
  return data;
}

export async function getBufferEstatisticas(grupo_entrega) {
  const params = grupo_entrega ? `?grupo_entrega=${grupo_entrega}` : "";
  const { data } = await api.get(`/buffer/estatisticas${params}`);
  return data;
}

export async function getBufferTickets(params = {}) {
  const qs = new URLSearchParams(params).toString();
  const { data } = await api.get(`/buffer/tickets${qs ? `?${qs}` : ""}`);
  return data;
}
